import { createFileRoute, Navigate } from '@tanstack/react-router';
import { MySchedule } from '@/components/MySchedule';
import { useCurrentCrewMember } from '@/hooks/useCurrentCrewMember';

export const Route = createFileRoute('/_auth/schedule/')({
  component: ScheduleRoute,
});

function ScheduleRoute() {
  const { data: currentUser } = useCurrentCrewMember();
  // Crew excluded from scheduling have no schedule — send them home.
  if (currentUser?.includeInSchedule === false) {
    return <Navigate to="/home" />;
  }
  return <MySchedule />;
}
